export default "__VITE_ASSET__ORyEa9Oa__"